import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {
    CommandBarButton, DefaultButton, Dialog, DialogFooter, DialogType,
    Dropdown,
    IDropdownOption, MessageBarType, PrimaryButton, TextField, Toggle,
    // PrimaryButton
} from "office-ui-fabric-react";
import * as H from "history";
import DispatchProps from "../../../../utils/DispatchProps";
import {IRootState} from "../../../../store";
import School from "../../../../models/School";
import SchoolList from "../../../SchoolList";
import ApiService from "../../../ApiService";
import {WorkloadInfo} from "../../../../models/WorkloadInfo";
import SchoolFilterControls, {SchoolFilter} from "../../../SchoolFilterControls";
import {debounce} from "throttle-debounce";
import Actions from "../../../../redux/Actions";
import {parseQueryString} from "../../../../utils/Utils";

interface NewBulkWorkloadPageProps {
    apiService: ApiService;
    history: H.History;
    showCustomEntry: boolean;
}

interface NewBulkWorkloadPageState {
    schoolsLoading: boolean;
    schoolsFilter: SchoolFilter;
    schools?: School[];
    selectedSchools: School[];
    selectedSchoolCodes: Map<string, boolean>;

    selectedWorkloadName?: string;
    workloadNameOptions?: IDropdownOption[];
    startPaused: boolean;
    
    showConfirmation: boolean;
    startingBulkWorkload: boolean;
    
    csvSchoolsToSelect: string;
}

class NewBulkWorkloadPage extends Component<NewBulkWorkloadPageProps & DispatchProps ,NewBulkWorkloadPageState> {
    static displayName = NewBulkWorkloadPage.name;

    private readonly debouncedLoadSchoolsForFilter: debounce<() => void>;

    constructor(props: NewBulkWorkloadPageProps & DispatchProps) {
        super(props);

        this.debouncedLoadSchoolsForFilter = debounce(200,this.loadSchoolsForFilter);

        this.state = {
            schoolsFilter: {showDisabled: false,showExpired: false,showOnlyThirdPartySds: false,licenses:[],onboardStatuses: [],filterString: ""},
            schoolsLoading: false,
            schools: undefined,
            selectedSchools: [],
            selectedSchoolCodes: new Map<string, boolean>(),
            
            selectedWorkloadName: undefined,
            workloadNameOptions: undefined,
            startPaused: false,
            
            showConfirmation: false,
            startingBulkWorkload: false,
            
            csvSchoolsToSelect: ""
        }
    }

    async componentDidMount() {
        const workloadInfos = await this.props.apiService.getWorkloads();
        const workloadNameOptions = workloadInfos.map((workloadInfo: WorkloadInfo): IDropdownOption => {
            return {
                key: workloadInfo.name,
                text: workloadInfo.name,
                data: workloadInfo.name
            };
        });
        
        this.setState({
            workloadNameOptions: workloadNameOptions
        });
        
        await this.loadSchoolsForFilter();
    }

    
    private async loadSchoolsForFilter()
    {
        this.setState({
            schoolsLoading: true
        });
        
        const schools = await this.props.apiService.getSchoolsAdmin(this.state.schoolsFilter.showDisabled,this.state.schoolsFilter.showExpired,this.state.schoolsFilter.showOnlyThirdPartySds,this.state.schoolsFilter.licenses,this.state.schoolsFilter.onboardStatuses,this.state.schoolsFilter.filterString);

        const selectedSchools = this.CalculateSelectedSchools(schools, this.state.selectedSchoolCodes);

        this.setState({
            schools: schools,
            schoolsLoading: false,
            selectedSchools: selectedSchools
        });

       
    }
    
    async componentDidUpdate(prevProps: Readonly<NewBulkWorkloadPageProps & DispatchProps>, prevState: any): Promise<void> {
        if(this.state.schoolsFilter !== prevState.schoolsFilter)
        {
            this.debouncedLoadSchoolsForFilter();
        }
    }
    
    private startBulkWorkload = async (): Promise<void> => 
    {
        if (this.state.selectedWorkloadName === undefined || this.state.selectedSchools === undefined || this.state.selectedSchools.length === 0)
        {
            return;
        }
        
        
        this.setState({
            startingBulkWorkload: true
        });
        
        try
        {
            const schoolRefs = this.state.selectedSchools.map(school => {
                return {tenantId: school.tenantId!, tenantName: school.tenantName!, schoolCode: school.schoolCode!};
            });
            const bulkCommand = {
                bulkWorkloadName: this.state.selectedWorkloadName,
                schools: schoolRefs,
                startPaused: this.state.startPaused
            }
            const instance = await this.props.apiService.triggerBulkWorkload(bulkCommand);
            this.props.dispatch(Actions.showMessageBar(`Successfully started ${this.state.selectedWorkloadName} at ${this.state.selectedSchools?.length} schools`, MessageBarType.success));
            
            this.props.history.push(`/cdb-admin/workloads/${instance.durableFunctionInstanceId}`)
        }
        catch (e)
        {
            this.props.dispatch(Actions.showMessageBar(`Could not start bulk workload: ${e}`, MessageBarType.error));
        }

        this.setState({
            showConfirmation: false,
            startingBulkWorkload: false,
        });
    }
    
    private buildCustomEntryArea = (): JSX.Element| null =>
    {
        if(!this.props.showCustomEntry)
        {
            return null;
        }
        
        return (
            <Fragment>
                <TextField label="tenantId,schoolCode (csv no headers)" multiline rows={10}
                           value={this.state.csvSchoolsToSelect} onChange={(e: any) => {
                    this.setState({
                        csvSchoolsToSelect: e.target.value
                    });
                }}/>
                <CommandBarButton
                    iconProps={{iconName: "Rocket"}}
                    text={"Further filter schools from above csv"}
                    onClick={() => {
                        
                        if (!this.state.schools) {
                            return
                        }
                        const lines = this.state.csvSchoolsToSelect.split("\n");
                        const newSelected = this.state.schools.filter(s => {
                            return lines.includes(`${s.tenantId},${s.schoolCode}`);
                        });

                        this.setState({
                            schools: newSelected
                        });
                    }}
                />
            </Fragment>
        );
    }

    private onSelectionChange = async (selection: Map<string, boolean>) => {   

        const selectedSchools = this.CalculateSelectedSchools(this.state.schools, selection);

        this.setState({
            selectedSchoolCodes: selection,
            selectedSchools: selectedSchools
        });      
    }    

    private CalculateSelectedSchools(schools: School[] | undefined, selectedSchoolCodes: Map<string, boolean>): School[] {
        if (schools !== undefined) {
            return schools.filter(x => x.schoolCode !== undefined && selectedSchoolCodes.get(SchoolList.getSelectedSchoolKey(x)) === true)
        }

        return [];
    }
       
    render() {

        return (
            <Fragment>
                {this.buildCustomEntryArea()}
                <SchoolFilterControls filter={this.state.schoolsFilter} filterChanged={(newFilter) => {
                    this.setState({schoolsFilter: newFilter});
                }}/>
                <SchoolList schools={this.state.schools || []}
                    title={"Start bulk workload at schools"}
                    enableRowLinks={false}
                    loading={this.state.schoolsLoading}
                    selectable={true}
                    onSelectionChange={this.onSelectionChange}>
                    <Toggle
                        inlineLabel={true}
                        checked={this.state.startPaused}
                        onChange={(event, newValue) => {
                            this.setState({
                                startPaused: newValue!
                            });
                        }}
                        role="switch"
                        label={"Start paused"}
                    />
                    <Dropdown
                        className="filter-controls__input"
                        styles={{ dropdown: { width: 300 } }}
                        selectedKey={this.state.selectedWorkloadName}
                        onChange={(event: any, option: any) => {
                            this.setState({selectedWorkloadName: option.data});
                        }}
                        options={this.state.workloadNameOptions || []}
                        placeholder="Select a workload"
                    />
                    <CommandBarButton
                        iconProps={{ iconName: "Rocket" }}
                        text={`Start at ${this.state.selectedSchools?.length} schools`}
                        disabled={this.state.selectedWorkloadName === undefined || !this.state.selectedSchools?.length}
                        onClick={() => {
                            this.setState({
                                showConfirmation: true
                            });
                        }}
                    />
                </SchoolList>

                <Dialog
                    hidden={!this.state.showConfirmation}
                    onDismiss={() => { this.setState({showConfirmation: false}); }}
                    dialogContentProps={{
                        type: DialogType.largeHeader,
                        title: `Bulk Start ${this.state.selectedWorkloadName}`,
                        subText: `Are you sure you want to start ${this.state.selectedWorkloadName} at ${this.state.selectedSchools?.length} schools?`
                    }}
                    modalProps={{
                        isBlocking: false,
                    }}>
                    
                    <DialogFooter>
                        <PrimaryButton disabled={this.state.startingBulkWorkload} onClick={() => this.startBulkWorkload()} text={`Start ${this.state.selectedWorkloadName}`} />
                        <DefaultButton disabled={this.state.startingBulkWorkload} onClick={() => { this.setState({showConfirmation: false}); }} text="Cancel" />
                    </DialogFooter>
                </Dialog>
                
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): NewBulkWorkloadPageProps => {

        return {
            apiService: state.auth.apiService,
            history: ownProps.history,
            showCustomEntry: parseQueryString(ownProps.history.location.search)["showCustomEntry"] === "true"
        };
    }
)(NewBulkWorkloadPage)